// MainContent.js
import React from 'react';
import './mainContent.css';
import { Route, Routes } from 'react-router-dom';
import Dashboard from '../pages/dashboard/Dashboard';
import {
  Account,
  AccountList,
  AccountAdd,
  AccountUpdate,
  BusinessUnit,
  BusinessUnitList,
  BusinessUnitAdd,
  External,
  ExternalList,
  ExternalAdd,
  Internal,
  InternalList,
  InternalAdd,
  InternalUpdate,
  Project,
  ProjectList,
  ProjectAdd,
  NewTransaction,
  NewTransactionList,
  NewTransactionAdd,
  ProjectCost,
  ProjectCostList,
  ProjectCostAdd,
} from '../pages/master_data';
import {
  DailyTransaction,
  DailyTransactionList,
  DailyTransactionAdd,
  DailyTransactionView,
  TempTransaction,
  TempTransactionList,
  TempTransactionAdd,
  TempTransactionView,
  OpeningBalance,
  ProjectTransaction,
  ProjectTransactionList,
  ProjectTransactionAdd,
  ProjectTransactionView,
  ProjectCostTransaction,
  ProjectCostTransactionList,
  ProjectCostTransactionAdd,
} from '../pages/transaction';
import { CoaReport } from '../pages/report';
import Page404 from '../pages/errorPage/Page404';
import { Inquiry, InquiryList, InquiryView } from '../pages/inquiry';
import { Users, UsersList, UsersAdd } from '../pages/administration';

function MainContent() {
  return (
    <main id="main" className="main">
      <Routes>
        <Route path="/" element={<Dashboard />} />
        {/* Master Data */}
        <Route path="account" element={<Account />}>
          <Route path="" element={<AccountList />}></Route>
          <Route path="create" element={<AccountAdd />}></Route>
          <Route path="update/:id" element={<AccountUpdate />}></Route>
        </Route>
        <Route path="external" element={<External />}>
          <Route path="" element={<ExternalList />}></Route>
          <Route path="create" element={<ExternalAdd />}></Route>
          <Route path="update/:id" element={<ExternalAdd />}></Route>
        </Route>
        <Route path="internal" element={<Internal />}>
          <Route path="" element={<InternalList />}></Route>
          <Route path="create" element={<InternalAdd />}></Route>
          <Route path="update/:id" element={<InternalUpdate />}></Route>
        </Route>
        <Route path="project" element={<Project />}>
          <Route path="" element={<ProjectList />}></Route>
          <Route path="create" element={<ProjectAdd />}></Route>
          <Route path="update/:id" element={<ProjectAdd />}></Route>
        </Route>
        <Route path="business-unit" element={<BusinessUnit />}>
          <Route path="" element={<BusinessUnitList />}></Route>
          <Route path="create" element={<BusinessUnitAdd />}></Route>
          <Route path="update/:id" element={<BusinessUnitAdd />}></Route>
        </Route>
        <Route path="users" element={<Users />}>
          <Route path="" element={<UsersList />}></Route>
          <Route path="create" element={<UsersAdd />}></Route>
          <Route path="update/:id" element={<UsersAdd />}></Route>
        </Route>
        <Route path="new-transaction" element={<NewTransaction />}>
          <Route path="" element={<NewTransactionList />}></Route>
          <Route path="create" element={<NewTransactionAdd />}></Route>
          <Route path="update/:id" element={<NewTransactionAdd />}></Route>
        </Route>
        <Route path="project-cost" element={<ProjectCost />}>
          <Route path="" element={<ProjectCostList />}></Route>
          <Route path="create" element={<ProjectCostAdd />}></Route>
          <Route path="update/:id" element={<ProjectCostAdd />}></Route>
        </Route>

        {/* Transaction */}
        <Route path="temporary-transaction" element={<TempTransaction />}>
          <Route path="" element={<TempTransactionList />}></Route>
          <Route path="create" element={<TempTransactionAdd />}></Route>
          <Route path="update/:id"></Route>
          <Route path="view/:id" element={<TempTransactionView />}></Route>
        </Route>
        <Route path="project-transaction" element={<ProjectTransaction />}>
          <Route path="" element={<ProjectTransactionList />}></Route>
          <Route path="create" element={<ProjectTransactionAdd />}></Route>
          <Route path="view/:id" element={<ProjectTransactionView />}></Route>
        </Route>
        <Route path="daily-transaction" element={<DailyTransaction />}>
          <Route path="" element={<DailyTransactionList />}></Route>
          <Route path="create" element={<DailyTransactionAdd />}></Route>
          <Route path="view/:id" element={<DailyTransactionView />}></Route>
        </Route>
        <Route path="opening-balance" element={<OpeningBalance />} />
        <Route
          path="project-cost-transaction"
          element={<ProjectCostTransaction />}
        >
          <Route path="" element={<ProjectCostTransactionList />}></Route>
          <Route path="create" element={<ProjectCostTransactionAdd />}></Route>
          <Route
            path="view/:id"
            element={<ProjectCostTransactionAdd />}
          ></Route>
        </Route>

        <Route path="coa-report" element={<CoaReport />} />
        <Route path="inquiry" element={<Inquiry />}>
          <Route path="" element={<InquiryList />}></Route>
          <Route path="view/:id" element={<InquiryView />}></Route>
        </Route>

        {/* Page 404 */}
        <Route path="*" element={<Page404 />} />
      </Routes>
    </main>
  );
}

export default MainContent;
